function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { LocaleCode } from '@tablecheck/locales';
import { Romanizer } from '../Romanizer.js';
/* eslint-disable eslint-comments/disable-enable-pair, class-methods-use-this */

var JAMO = [['g', 'gg', 'n', 'd', 'dd', 'r', 'm', 'b', 'bb', 's', 'ss', '', 'j', 'jj', 'ch', 'kh', 'th', 'ph', 'h'], ['a', 'ae', 'ya', 'yae', 'eo', 'e', 'yeo', 'ye', 'o', 'wa', 'wae', 'oi', 'yo', 'u', 'wo', 'we', 'wi', 'yu', 'eu', 'ui', 'i'], ['', 'g', 'gg', 'gs', 'n', 'nj', 'nh', 'd', 'r', 'rg', 'rm', 'rb', 'rs', 'rth', 'rph', 'rh', 'm', 'b', 'bs', 's', 'ss', 'ng', 'j', 'ch', 'kh', 'th', 'ph', 'h']];

var Korean = /*#__PURE__*/function (_Romanizer) {
  _inherits(Korean, _Romanizer);

  var _super = _createSuper(Korean);

  function Korean() {
    _classCallCheck(this, Korean);

    return _super.apply(this, arguments);
  }

  _createClass(Korean, [{
    key: "normalizeForQuery",
    value: function normalizeForQuery(str) {
      return this._romanizeName(str) || str;
    }
  }, {
    key: "_toJamos",
    value: function _toJamos(hangul) {
      var chars = [];

      for (var i = 0; i < hangul.length; i += 1) {
        var n = hangul.charCodeAt(i);

        if (n >= 44032 && n <= 55203) {
          n -= 44032;
          var j1 = Math.floor(n / 588);
          n -= j1 * 588;
          var j2 = Math.floor(n / 28);
          var j3 = n - j2 * 28;
          chars.push([JAMO[0][j1], JAMO[1][j2], JAMO[2][j3]]);
        } else return null;
      }

      return chars;
    }
  }, {
    key: "_syllableHandler",
    value: function _syllableHandler(
    /** char jamos  */
    curr, prev) {
      var next = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var j1 = curr[0];
      var j2 = curr[1];
      var j3 = curr[2]; // Make entry consonant.

      switch (j1) {
        case 'g':
          j1 = 'k';
          if (curr[1] === 'o' || curr[1] === 'a' || curr[1] === 'yu') j1 = 'g';
          if (prev) if (curr[1] === 'i') j1 = 'g';
          break;

        case 'gg':
          j1 = 'kk';
          break;

        case 'dd':
          j1 = 'tt';
          break;

        case 'r':
          if (curr[1] === 'u') {
            j1 = 'l';
          } else if (prev) {
            if (!next && (prev[2] === 'n' || prev[2] === 'r')) j1 = 'l';
          }

          break;

        case 'bb':
          j1 = 'pp';
          break;

        case 'kh':
          j1 = 'k';
          break;

        case 'th':
          j1 = 't';
          break;

        case 'ph':
          j1 = 'p';
          break;

        default:
      } // Make vowel.


      if (j2 === 'oi') j2 = 'oe'; // Make final consonant.

      switch (j3) {
        case 'g':
          j3 = 'k';

          if (next) {
            if (next[0] === 'n' || next[0] === 'r' || next[0] === 'm') {
              j3 = 'ng';
            } else if (next[0] === '') {
              j3 = 'g';
            }
          }

          break;

        case 'gg':
          j3 = 'k';
          break;

        case 'gs':
          j3 = 'ks';
          break;

        case 'n':
          if (next && next[0] === 'r') j3 = 'l';
          break;

        case 'd':
          j3 = 't';

          if (next) {
            if (next[0] === '') {
              j3 = 'd';
            } else if (next[0] === 'n' || next[0] === 'r' || next[0] === 'm') {
              j3 = 'n';
            }
          }

          break;

        case 'r':
          j3 = 'l';
          if (next && next[0] === '') j3 = 'r';
          break;

        case 'rg':
          j3 = 'lk';
          if (next && next[0] === '') j3 = 'lg';
          break;

        case 'rm':
          j3 = 'lm';
          break;

        case 'rb':
          j3 = 'lp';
          if (next && next[0] === '') j3 = 'lb';
          break;

        case 'rs':
          j3 = 'ls';
          break;

        case 'rth':
          j3 = 'lt';
          break;

        case 'rph':
          j3 = 'lp';
          break;

        case 'rh':
          j3 = 'lh';
          break;

        case 'b':
          j3 = 'p';

          if (next) {
            if (next[0] === 'n' || next[0] === 'r' || next[0] === 'm') {
              j3 = 'm';
            } else if (next[0] === '') {
              j3 = 'b';
            }
          }

          break;

        case 's':
          j3 = 't';
          if (next && (next[0] === '' || next[0] === 's' || next[0] === 'ss')) j3 = 's';
          break;

        case 'ss':
          j3 = 't';
          if (next && next[0] === '') j3 = 'ss';
          break;

        case 'j':
          j3 = 't';
          break;

        case 'ch':
          j3 = 't';
          break;

        case 'kh':
          j3 = 'k';
          break;

        case 'th':
          j3 = 't';
          break;

        case 'ph':
          j3 = 'p';
          break;

        default:
      }

      var syllable = "".concat(j1).concat(j2).concat(j3);
      return syllable;
    }
  }, {
    key: "_romanizeName",
    value: function _romanizeName(hangul) {
      var chars = this._toJamos(hangul);

      if (!chars) return null;
      var englishName = '';
      var syllable = '';

      for (var i = 0; i < chars.length; i += 1) {
        syllable = this._syllableHandler(chars[i], i === 0 ? null : chars[i - 1], chars[i + 1]);
        englishName += syllable;
      }

      return englishName;
    }
  }, {
    key: "_transliterateKoreanName",
    value: function _transliterateKoreanName(hangul, isLastName) {
      if (!hangul) return null;

      var englishName = this._romanizeName(hangul);

      if (englishName && isLastName) {
        if (englishName.startsWith('i') || englishName.startsWith('ri')) englishName = englishName.replace(/i|ri/, 'lee');
        if (englishName.startsWith('bak')) englishName = englishName.replace(/bak/, 'park');
        if (englishName.startsWith('choe')) englishName = englishName.replace(/choe/, 'choi');
        if (englishName.startsWith('jo')) englishName = englishName.replace(/jo/, 'cho');
        if (englishName.startsWith('gang')) englishName = englishName.replace(/gang/, 'kang');
        if (englishName.startsWith('sin')) englishName = englishName.replace(/sin/, 'shin');
        if (englishName.startsWith('o')) englishName = englishName.replace(/o/, 'oh');
        if (englishName.startsWith('an')) englishName = englishName.replace(/an/, 'ahn');
        if (englishName.startsWith('go')) englishName = englishName.replace(/go/, 'ko');
        if (englishName.startsWith('yu')) englishName = englishName.replace(/yu/, 'yoo');
        if (englishName.startsWith('leem')) englishName = englishName.replace(/leem/, 'im');
      }

      return englishName;
    }
  }, {
    key: "formatName",
    value: function formatName(name) {
      return name || '';
    }
  }, {
    key: "isNative",
    value: function isNative(char) {
      return /[\uac00-\ud7af]|[\u1100-\u11ff]|[\u3130-\u318f]|[\ua960-\ua97f]|[\ud7b0-\ud7ff]/g.test(char);
    }
  }, {
    key: "isMatch",
    value: function isMatch(locale) {
      return locale === LocaleCode.Korean;
    }
  }, {
    key: "transliterateName",
    value: function transliterateName(char, isLastName) {
      var isFullName = /\s/.test(char);
      if (isFullName) return char;
      return this._transliterateKoreanName(char, isLastName);
    }
  }]);

  return Korean;
}(Romanizer);

export { Korean };
